import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { ChevronRight, Clock } from "react-feather";
import { getDashboardUpcomingEvents } from "../../../../actions/adminDashboardActions";

const MAX_ROWS = 6;
const TIME_FORMATS = ["HH:mm:ss", "HH:mm", "h:mm A", "hh:mm A", "h:mmA"];

const formatTime = (value) => {
  if (!value) return "";
  const t = moment(value, TIME_FORMATS, true);
  return t.isValid() ? t.format("h:mm A") : String(value);
};

const dayLabel = (date) => {
  const today = moment().startOf("day");
  const diff = date.clone().startOf("day").diff(today, "days");
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  return date.format("dddd");
};

const STATUS = {
  P: { label: "Pending", tone: "warning" },
  A: { label: "Scheduled", tone: "brand" },
  C: { label: "Confirmed", tone: "success" },
};

const UpcomingBookings = (props) => {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    props.getDashboardUpcomingEvents({
      onSuccess: (data) => {
        const list = Array.isArray(data)
          ? data
          : Array.isArray(data && data.dataSet)
            ? data.dataSet
            : Array.isArray(data && data.data && data.data.dataSet)
              ? data.data.dataSet
              : [];
        setRows(list);
        setStatus("ready");
      },
      onError: () => setStatus("error"),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const visible = rows.slice(0, MAX_ROWS);

  return (
    <section className="dash-card dash-card--list">
      <header className="dash-card__header">
        <div className="dash-card__titles">
          <h3 className="dash-card__title">Upcoming bookings</h3>
          <p className="dash-card__subtitle">
            {status === "ready" && rows.length
              ? `${rows.length} in the next 7 days`
              : "Next 7 days"}
          </p>
        </div>
        <Link to="/admin/scheduled-events" className="dash-link">
          View all <ChevronRight size={14} />
        </Link>
      </header>

      {status === "loading" ? (
        <ul className="dash-agenda dash-agenda--skeleton" aria-hidden="true">
          {Array.from({ length: 4 }).map((_, i) => (
            <li key={i}>
              <span className="dash-agenda__date" />
              <span className="dash-agenda__lines">
                <span />
                <span />
              </span>
            </li>
          ))}
        </ul>
      ) : status === "error" ? (
        <div className="dash-empty dash-empty--inline">
          <div className="dash-empty__title">Couldn't load upcoming bookings</div>
          <div className="dash-empty__text">Refresh the page to try again.</div>
        </div>
      ) : visible.length === 0 ? (
        <div className="dash-empty dash-empty--inline">
          <span className="dash-empty__icon">
            <Clock size={18} />
          </span>
          <div className="dash-empty__title">Nothing scheduled this week</div>
          <div className="dash-empty__text">New bookings will appear here as they come in.</div>
        </div>
      ) : (
        <ul className="dash-agenda">
          {visible.map((row) => {
            const date = row.booking_date_time
              ? moment(row.booking_date_time, "YYYY-MM-DD HH:mm:ss")
              : moment(row.booking_date, "DD-MM-YYYY");
            const badge = STATUS[row.status_code] || { label: row.booking_status || "Scheduled", tone: "brand" };
            const start = formatTime(row.start_time);
            const end = formatTime(row.end_time);
            return (
              <li key={row.id}>
                <span className="dash-agenda__date">
                  <span>{date.format("MMM")}</span>
                  <strong>{date.format("D")}</strong>
                </span>
                <span className="dash-agenda__lines">
                  <span className="dash-agenda__name">{row.attendee_name || "Guest"}</span>
                  <span className="dash-agenda__meta">
                    {row.event_name}
                    {start ? ` · ${dayLabel(date)}, ${start}${end ? `–${end}` : ""}` : ` · ${dayLabel(date)}`}
                  </span>
                </span>
                <span className={`dash-badge dash-badge--${badge.tone}`}>{badge.label}</span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default connect(null, { getDashboardUpcomingEvents })(UpcomingBookings);
